import { atom } from "recoil";
export const productNoFocusState = atom({
  key: "productNoFocusState",
  default: false,
});
